// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3fgTD","content":"LayoutSettings_content__2XAEJ"};